import React from 'react';
import Link from 'next/link';

import classes from './ExploreCareerCard.module.scss';

const ExploreCareerCard = ({ career }) => {
    return (

        <div className={classes['wrapper']}>
            <Link href={`/career-path/${career.id}/${career.slug}`} className={classes['card']}>
                <div
                    style={{ backgroundImage: `url(${career.image})` }}
                    className={classes['image']}
                >
                </div>
                <div className={classes['content']}>
                    <h3>{career.name}</h3>
                    <p>{career.description}</p>
                    <span > {career.lecture_count} Courses</span>
                </div>
            </Link>
        </div>

    );
};

export default ExploreCareerCard;